module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "navigation-drawer-with-toggle",
    attrs: {
      "temporary": "",
      "fixed": "",
      "right": "",
      "value": _vm.isOpen
    },
    on: {
      "input": function (value) { return _vm.$emit('input', value); }
    }
  }, [_c('button', {
    staticClass: "toggle-button lighten-3",
    class: _vm.themeColor,
    on: {
      "click": function($event) {
        _vm.$emit('input', !_vm.isOpen)
      }
    }
  }, [(_vm.isOpen) ? _c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_right")]) : _c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49660984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationDrawerWithToggle.vue
// module id = 433
// module chunks = 1